import { render, staticRenderFns } from "./lawChar.vue?vue&type=template&id=a2283214&"
import script from "./lawChar.vue?vue&type=script&lang=js&"
export * from "./lawChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports